import { fg } from '@atlaskit/platform-feature-flags';

import { DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-comment-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-branch-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI } from '../../../types/default-cloud-graph-devinfo-commit-entity-ati';
import { DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI } from '../../../types/default-cloud-graph-document-entity-ati';
import { DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI } from '../../../types/default-cloud-graph-project-entity-ati';
import { DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI } from '../../../types/default-cloud-graph-work-item-entity-ati';
import type { FilterId } from '../../../types/filters';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { ForgePioGithubIcon, ForgePioGithubSearchResultIcon } from './icon';

export const forgePioGithubConfig: ThirdPartyConfig = {
	displayName: 'Github by Pio',
	id: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
	resourceType: ProductResourceTypes3P.ForgePioGithubDev,
	icon: get3PLogo(ForgePioGithubIcon, 'ForgePioGithub', 'medium'),
	searchResultIcon: get3PLogo(ForgePioGithubSearchResultIcon, 'ForgePioGithub', 'large'),
	integrationAri: 'ari:cloud:platform::integration/3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j',
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Document,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Comment,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Commit,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_COMMIT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Branch,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_DEVINFO_BRANCH_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.Project,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_PROJECT_ENTITY_ATI,
				subTypes3P: [],
			},
		],
		[
			TypeFilterValueKey.WorkItem,
			{
				entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
				subTypes3P: [],
			},
		],
	]),
	get filters(): FilterId[] {
		const baseFilters: FilterId[] = ['lastUpdated'];
		if (fg('platform_search_3p_config_consolidation')) {
			baseFilters.push('pullRequestStatus');
		}
		if (fg('rovo_fps_show_repository_filter')) {
			baseFilters.push('repository');
		}
		if (fg('rovo_fps_show_github_created_by_filter')) {
			baseFilters.push('createdBy');
		}
		return baseFilters;
	},
	requiresOauth: false,
	isEnabled: () => true,
	displayWorkspaceNameAsProductName: true,
};
